module.exports = __webpack_public_path__ + "static/media/komma-rum-web-2.ae88d8e5.png";